import * as React from "react"
import { observer } from "mobx-react";
import { makeStyles } from "@material-ui/core";
import { MUIDialog } from "../../entryes/panel/MUI";
import CloseIcon from "../Icons/close";
import { tl } from "../../utils";
import { MobileGallerySlider } from "../MobileGallerySlider";
import { TsPromoVideoIcon } from "../Icons/tsPromoVideo";
import TsPromoTranscribeIcon from "../Icons/tsPromoTranscribe";
import TsPromoTextIcon from "../Icons/tsPromoText";

interface TranscriptionInfoPopupProps {
  open: boolean;
  onClose: () => void;
}


export const TranscriptionInfoPopup: React.FC<TranscriptionInfoPopupProps> = observer(({
  open, onClose
}) => {

  const classes = useStyles();
  return (
    <MUIDialog pInner={0} notFullWidth noclose notitle mobileFullWidth open={open} onClose={onClose} PaperProps={{className: classes.paper}}>
      <MobileGallerySlider className={classes.scrollContainer} itemClassName={classes.stepCardWrap} controlMargin={-40}>
        <div className={classes.stepCard}>
          <TsPromoVideoIcon className={classes.stepIcon} />
          <div className={classes.stepTextContainer}>
            <span><strong>{tl('Шаг 1')}</strong></span>
            <span className={classes.stepHeader}><strong>{tl('Выберите видео для которого нужно получить транскриб')}</strong></span>
            <span className={classes.stepDesc}>{tl('В уроке или в хранилище файлов')}</span>
          </div>
        </div>
        <div className={classes.stepCard}>
          <TsPromoTranscribeIcon className={classes.stepIcon} />
          <div className={classes.stepTextContainer}>
            <span><strong>{tl('Шаг 2')}</strong></span>
            <span className={classes.stepHeader}><strong>{tl('Нажмите Транскрибировать')}</strong></span>
            <span className={classes.stepDesc}>{tl('Кнопка будет рядом с видео и дождитесь расшифровки ')}</span>
          </div>
        </div>
        <div className={classes.stepCard}>
          <TsPromoTextIcon className={classes.stepIcon} />
          <div className={classes.stepTextContainer}>
            <span><strong>{tl('Шаг 3')}</strong></span>
            <span className={classes.stepHeader}><strong>{tl('Опубликуйте итоговый текст в урок или попробуйте другую модель')}</strong></span>
            <span className={classes.stepDesc}>{tl('Вам доступны базовая и продвинутая модель распознования текста')}</span>
          </div>
        </div>
      </MobileGallerySlider>
      <CloseIcon className={classes.closeIcon} onClick={() => onClose()}></CloseIcon>
    </MUIDialog>
  )
});


const useStyles = makeStyles((theme) => ({
  paper: {
    margin: 0,
    borderRadius: 20,
  },
  closeIcon: {
    cursor: 'pointer',
    position: 'absolute',
    top: 20,
    right: 20,
    color: '#5667F6',

    '@media screen and (max-width: 425px)': {
      right: 'calc(50% - 10px)',
    },
  },
  scrollContainer: {
    display: 'flex',
    padding: 60,
    gap: 48,
  },
  stepCardWrap: {
    width: 278,
    minWidth: 278,
    padding: '20px 0',
    boxShadow: '0px 20px 40px 0px rgba(0, 0, 0, 0.10)',
    fontSize: 13,
    lineHeight: '16px',
    borderRadius: 12,
  },
  stepCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  stepIcon: {
    width: 64,
    height: 64,
  },
  stepTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: 12,
    marginTop: 20,
  },
  stepHeader: {
    display: 'inline-block',
    height: 32,
  },
  stepDesc: {
    marginTop: 20,
  },
  heading: {
    fontFamily: 'Roboto Flex',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: 30,
    lineHeight: 'normal',
    textAlign: 'center',
    marginTop: 60,
    marginBottom: 80,

    [theme.breakpoints.down("sm")]: {
      marginTop: 45,
      marginBottom: 50,
    },
    '@media screen and (max-width: 425px)': {
      fontSize: 26,
      marginTop: 45,
      marginBottom: 0,
    },
  },
}))